import * as React from "react";
type Props = {
  className?: string,
};
function SvgNoCilantro({ className }: Props) {
  return (
    <svg
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-NoCilantro"
      className={className}
    >
      <g clipPath="url(#clip0_146_986)">
        <path
          d="M19.7523 8.44629C19.7523 8.44629 15.8388 13.3879 21.236 16.764C21.7447 16.143 22.1131 15.4192 22.3155 14.6424C22.5179 13.8655 22.5497 13.054 22.4088 12.2637C22.2678 11.4734 21.9575 10.723 21.4989 10.064C21.0404 9.40504 20.4444 8.85312 19.7523 8.44629Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M13.0698 15.8878C13.0698 15.8878 16.3176 21.2966 21.376 17.4415C20.9751 16.7458 20.428 16.1452 19.7729 15.681C19.1177 15.2168 18.37 14.9 17.5807 14.7524C16.7915 14.6047 15.9796 14.6298 15.2009 14.8258C14.4223 15.0218 13.6951 15.3841 13.0698 15.8878V15.8878Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M28.5256 11.9393C28.5256 11.9393 28.2103 18.2361 21.9253 17.2197C21.9515 16.4168 22.1514 15.6291 22.5111 14.9109C22.8709 14.1927 23.3821 13.561 24.0093 13.0592C24.6366 12.5574 25.365 12.1975 26.1447 12.0042C26.9244 11.8109 27.7366 11.7887 28.5256 11.9393V11.9393Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M12.5444 38.2594C12.5444 38.2594 18.2686 40.9229 20.3013 34.8949C19.5793 34.5421 18.7894 34.35 17.986 34.3319C17.1826 34.3137 16.3848 34.4699 15.6475 34.7896C14.9103 35.1094 14.2512 35.5852 13.7155 36.1842C13.1798 36.7832 12.7803 37.4911 12.5444 38.2594V38.2594Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M20.056 43.785C20.056 43.785 25.1962 40.1402 20.9672 35.3856C20.3046 35.8388 19.7482 36.43 19.3358 37.1188C18.9235 37.8075 18.6649 38.5774 18.5783 39.3755C18.4917 40.1736 18.5791 40.981 18.8342 41.7422C19.0892 42.5034 19.506 43.2003 20.056 43.785V43.785Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M13.7944 28.8668C13.7944 28.8668 19.9976 27.6987 20.4533 34.0655C19.6666 34.2248 18.8547 34.2119 18.0735 34.0277C17.2922 33.8436 16.5602 33.4925 15.9275 32.9985C15.2949 32.5046 14.7764 31.8796 14.4082 31.1663C14.04 30.4531 13.8307 29.6687 13.7944 28.8668Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M42.1589 20.479C42.1589 20.479 36.3993 23.0256 39.5769 28.5279C40.3177 28.2173 40.9825 27.75 41.5254 27.1579C42.0683 26.5658 42.4765 25.8631 42.7219 25.0981C42.9672 24.3332 43.0438 23.5242 42.9466 22.7268C42.8494 21.9293 42.5808 21.1626 42.1589 20.479V20.479Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M33.0582 22.465C33.0582 22.465 32.4155 28.7266 38.7824 28.6799C38.8794 27.8823 38.802 27.0731 38.5556 26.3084C38.3093 25.5436 37.8998 24.8416 37.3554 24.2506C36.8111 23.6596 36.1449 23.1938 35.4029 22.8856C34.6609 22.5773 33.861 22.4338 33.0582 22.465V22.465Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M48.4207 27.5934C48.4207 27.5934 45.1848 33.0022 40.1147 29.1705C40.5137 28.473 41.0589 27.8702 41.7131 27.4037C42.3673 26.9372 43.1149 26.6181 43.9043 26.4682C44.6938 26.3183 45.5062 26.3413 46.2859 26.5355C47.0655 26.7298 47.7938 27.0907 48.4207 27.5934V27.5934Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M35.0211 37.8505C33.3272 37.0004 31.7225 35.9827 30.2313 34.813C28.8257 33.9731 27.1883 33.6048 25.5584 33.7617C24.5352 33.8244 23.5194 33.9729 22.5211 34.2057C21.6099 34.4043 20.8621 34.6145 20.3364 34.7664"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M21.4463 16.5887C21.8201 17.5934 22.3575 19.1121 22.8832 20.993C23.5257 23.2593 23.6192 24.0888 24.0514 25.4206C24.747 27.6907 25.8342 29.8218 27.264 31.7173C29.2485 34.3186 31.8448 36.3892 34.8224 37.7453C35.306 37.9702 35.8012 38.1691 36.3061 38.3411"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M39.5188 28.5981C39.5188 28.5981 34.5538 39.6028 35.7103 43.7851C36.8669 47.9673 40.8738 51.5421 40.8738 51.5421"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M28.0234 33.014L33.9113 25.9463"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M11.7969 52.465L19.7642 42.9089"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M1.08398 30C1.08398 24.1821 2.80926 18.4948 6.04152 13.6574C9.27378 8.81996 13.868 5.04977 19.2431 2.82335C24.6181 0.596936 30.5327 0.01429 36.2388 1.14931C41.9449 2.28433 47.1863 5.08593 51.3002 9.19982C55.4141 13.3137 58.2156 18.5551 59.3506 24.2612C60.4856 29.9674 59.9031 35.8819 57.6767 41.257C55.4503 46.632 51.6801 51.2261 46.8427 54.4584C42.0052 57.6906 36.318 59.4159 30.5001 59.4159C22.6985 59.4159 15.2162 56.3168 9.69964 50.8003C4.18309 45.2837 1.08398 37.8015 1.08398 30"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M36.2476 23.1542L49.2148 7.58179"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M22.5796 39.5327L27.4628 33.6799"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
      </g>
      <defs>
        <clipPath id="clip0_146_986">
          <rect
            width={60}
            height={60}
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default SvgNoCilantro;
